import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useBackButtonStyles } from './styles';
import { Link } from 'react-router-dom';
import { routerTreeMap } from '../../../config/navigationTree';
import { useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
  RPHONE,
  DEBIT,
  STORE,
  PROVIDERS,
  TICKET_SUCCESSFUL_INNER_FORMS,
} from '../../../constants/routes';

const BackButton = () => {
  const classes = useBackButtonStyles();
  const location = useLocation();
  return (
    <React.Fragment>
      {location.pathname !== TICKET_SUCCESSFUL_INNER_FORMS &&
        location.pathname !== RPHONE &&
        location.pathname !== DEBIT &&
        location.pathname !== STORE &&
        location.pathname !== PROVIDERS && (
          <Link
            className={classes.link}
            to={routerTreeMap.get(location.pathname)?.prevRoute}
          >
            <Box display="flex" justifyContent="center" alignItems="center">
              <ChevronLeftIcon />
              <Typography className={classes.type}>
                Volver a {routerTreeMap.get(location.pathname)?.titlePrevRoute}{' '}
              </Typography>
            </Box>
          </Link>
        )}
    </React.Fragment>
  );
};

export default BackButton;
